import React, { useState, useEffect, useCallback } from 'react';
import { fetchTakeoffRsvpAnalytics } from '../../api/client';
import TakeoffRsvpAnalytics from '../TakeoffRsvpAnalytics/TakeoffRsvpAnalytics';
import TakeoffRsvpList from '../TakeoffRsvpList/TakeoffRsvpList';

export default function TakeoffRsvpTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchTakeoffRsvpAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <TakeoffRsvpAnalytics analytics={analytics} />
      <TakeoffRsvpList />
    </div>
  );
}
